class EventUtil {

    /**
     * Checks whether two events are the same type, differing only in their date.
     * 
     * Two events are considered matching when they share times, session & room.
     * 
     * @param {object} event1 
     * @param {object} event2 
     * 
     * @returns {boolean} The result of the comparison
     */
    static eventsMatch(event1, event2) {
        const from1 = event1.from % (60 * 60 * 24)
        const to1 = event1.to % (60 * 60 * 24)
        const from2 = event2.from % (60 * 60 * 24)
        const to2 = event2.to % (60 * 60 * 24)

        return from1 === from2
            && to1 === to2
            && event1.ttsessiontype_id === event2.ttsessiontype_id
            && event1.ttroom_id === event2.ttroom_id
            && event1.tttimetable_id === event2.tttimetable_id
    }

    /**
     * Returns any events from the first array which match with at least one event in the second.
     * 
     * I.e. to determine which matching events are shared by two different dates, we can pass each date's events to this function.
     * 
     * @param {Array} events1 
     * @param {Array} events2 
     * 
     * @returns {Array} The matched events from 'events1'
     */
    static getMatchIntersection(events1, events2) {
        const result = []

        for (const e1 of events1) {
            for (const e2 of events2) {
                if (!this.eventsMatch(e1, e2)) continue
                result.push(e1)
                break
            }
        }

        return result
    }

    /**
     * Returns any events from the first array which do not match with any events in the second.
     * 
     * @param {Arrray} events1 
     * @param {Arrray} events2 
     */
    static getMatchCompliment(events1, events2) {
        const result = []

        outer: for (const e1 of events1) {
            for (const e2 of events2) {
                if (this.eventsMatch(e1, e2)) continue outer
            }
            result.push(e1)
        }

        return result
    }
}

export default EventUtil